// 9fbef606107a605d69c0edbcd8029e5d
import { takeLatest, call, put, select } from 'redux-saga/effects';
import logger from '@tcp/core/src/utils/loggerInstance';
import { makeSearch, makePopularSearch } from '@tcp/core/src/services/abstractors/common/searchBar';
import { getUnbxdXappConfigs } from '@tcp/core/src/components/features/browse/ProductListing/container/ProductListing.saga';
import ProductsOperator from '@tcp/core/src/components/features/browse/ProductListing/container/productsRequestFormatter';
import {
  getIsNonInvSessionFlag,
  getTrendingSearchState,
  getABTestIsEnhancedWebSearchBarEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import Abstractor from '@tcp/core/src/services/abstractors/productListing';
import SEARCH_CONSTANTS from './SearchBar.constants';
import {
  setSearchResult,
  setShowMoreProductFlag,
  setPopularSearch,
  setTrendingSearchResult,
  setTrendingSearchProducts,
} from './SearchBar.actions';

const instanceProductListing = new Abstractor();
const operatorInstance = new ProductsOperator();

export function* getTrendingSearchesState() {
  return yield select(getTrendingSearchState);
}
export function* getIsEnhancedWebSearchBarEnabled() {
  return yield select(getABTestIsEnhancedWebSearchBarEnabled);
}

export function* getSearchResult({ payload }) {
  const suggestionsCount = {
    category: 4,
    keywords: 4,
    promotedTopQueries: 4,
  };
  const { fromNewSearchBar } = payload;
  if (fromNewSearchBar !== undefined && fromNewSearchBar) return;
  const isHideBundleProduct = false;
  const payloadData = {
    searchTerm: payload.searchText,
    suggestionsCount,
    isHideBundleProduct,
    slpLabels: payload.slpLabels,
  };

  const xappURLConfig = yield call(getUnbxdXappConfigs);

  try {
    const isWebSearchEnabled = yield call(getIsEnhancedWebSearchBarEnabled);
    const response = yield call(makeSearch, payloadData, xappURLConfig, isWebSearchEnabled);
    if (
      response.autosuggestList &&
      response.autosuggestList[0].suggestions.length < 1 &&
      response.autosuggestProducts.length < 1
    ) {
      yield put(setSearchResult(response));
      yield put(setShowMoreProductFlag(false));
    } else {
      yield put(setSearchResult(response));
      yield put(setShowMoreProductFlag(true));
    }
  } catch (err) {
    logger.error('Error: error in fetching Search bar results ', {
      error: err,
      extraData: {
        component: 'SearchBar Saga - getSearchResult',
        payloadData: payload,
      },
    });
  }
}

export function* getTrendingSearchResult({ payload }) {
  const suggestionsCount = {
    category: 4,
    keywords: 4,
    promotedTopQueries: 4,
  };
  const isHideBundleProduct = false;
  const payloadTrendingSearch = {
    searchTerm: payload.searchText,
    suggestionsCount,
    isHideBundleProduct,
    slpLabels: payload.slpLabels,
    isSearchEnhancementCall: true,
  };
  const xappURLConfig = yield call(getUnbxdXappConfigs);
  let responseTrendingSearch = {};
  const trendingSearchState = yield call(getTrendingSearchesState);
  const webSearchEnhancementCheck = payload?.webSearchEnhancement && !trendingSearchState;
  const isWebSearchEnabled = yield call(getIsEnhancedWebSearchBarEnabled);
  try {
    if (webSearchEnhancementCheck) {
      responseTrendingSearch = yield call(
        makeSearch,
        payloadTrendingSearch,
        xappURLConfig,
        isWebSearchEnabled
      );
    }
    if (webSearchEnhancementCheck) {
      yield put(setTrendingSearchResult(responseTrendingSearch));
    }
  } catch (err) {
    logger.error('Error: error in fetching Search bar Trending Search results ', {
      error: err,
      extraData: {
        component: 'SearchBar Saga - getTrendingSearchResult',
        payloadData: payload,
      },
    });
  }
}

export function* getPopularSearch({ payload }) {
  const payloadData = {
    slpLabels: payload?.slpLabels,
  };

  const xappURLConfig = yield call(getUnbxdXappConfigs);
  try {
    const response = yield call(makePopularSearch, payloadData, xappURLConfig);

    yield put(setPopularSearch(response));
  } catch (err) {
    logger.error('Error: error in fetching Search bar results ', {
      error: err,
      extraData: {
        component: 'SearchBar Saga - getPopularSearch',
        payloadData: '',
      },
    });
  }
}

export function* fetchTrendingSearchProducts({ payload }) {
  try {
    const { url, numberOfProducts } = payload;
    yield put(
      setTrendingSearchProducts({
        fetchingTrendingProducts: true,
      })
    );
    const xappURLConfig = yield call(getUnbxdXappConfigs);
    const location = { pathname: url };
    const state = yield select();
    const isNonInvABTestEnabled = yield select(getIsNonInvSessionFlag);
    const reqObj = operatorInstance.getProductsListingFilters({
      state,
      pageNumber: 1,
      location,
    });
    reqObj.navigation = null;
    reqObj.extraParams = {
      ...reqObj.extraParams,
      numberOfProducts: 4,
    };
    reqObj.numberOfProducts = numberOfProducts;
    const res = yield call(
      instanceProductListing.getProducts,
      reqObj,
      state,
      null,
      null,
      xappURLConfig,
      isNonInvABTestEnabled,
      false
    );
    if (res) {
      yield put(
        setTrendingSearchProducts({
          fetchingTrendingProducts: false,
          trendingSearchProducts: { ...res },
        })
      );
    } else {
      throw new Error('Trending Search Products Api does noy return data');
    }
  } catch (err) {
    logger.error('Error: error in fetching Trending Search Products ', {
      error: err,
      extraData: {
        component: 'SearchBar Saga - fetchTrendingSearchProducts',
        payloadData: '',
      },
    });
  }
}

function* SearchBarSaga() {
  yield takeLatest(SEARCH_CONSTANTS.START_SEARCH, getSearchResult);
  yield takeLatest(SEARCH_CONSTANTS.TRENDING_SEARCH, getTrendingSearchResult);
  yield takeLatest(SEARCH_CONSTANTS.POPULAR_SEARCH, getPopularSearch);
  yield takeLatest(SEARCH_CONSTANTS.FETCH_TRENDING_SEARCH_PRODUCTS, fetchTrendingSearchProducts);
}

export default SearchBarSaga;
